import Layout from "@/components/Layout";
import SuccessPanel from "@/components/subscriptions/SuccessPanel";

export default function Success() {
  return (
    <Layout title="Setting up your subscription">
      <SuccessPanel />
    </Layout>
  );
}
